import { Component, Input, OnInit } from '@angular/core';
import { Integration } from 'src/app/shared/models/integration.model';

@Component({
  selector: 'app-help-amazon-spapi-details',
  templateUrl: './help-amazon-spapi-details.component.html'
})
export class HelpAmazonSpapiDetailsComponent implements OnInit {
  @Input() integration: Integration;

  constructor() { }

  ngOnInit(): void {
  }


}
